import ReactDOM from 'react-dom'

import App from './components/App'

import './fonts/fonts.css'

ReactDOM.render(<App />, document.querySelector('.root'))

/* DEPLOY VERCEL IN - medidor.artcoco@gmail.com */
